import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductPricing } from './pricing-details-dialog.component';
import { PricingDetailsDialogService } from './pricing-details-dialog.service';

export interface PricingDynamicInput {
  name?: string;
  code?: string;
}

@Component({
  selector: 'app-pricing-details-breakdown',
  templateUrl: './pricing-details-breakdown.component.html',
  styleUrls: ['./pricing-details-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingDetailsBreakdownComponent {
  @Input() productName: string;
  @Input() pricingInfo: ProductPricing[];

  _input: PricingDynamicInput;
  @Input() set input(input: PricingDynamicInput) {
    this._input = input;

    this.sumOfPriceBreakdown = PricingDetailsDialogService.getTotalCalculation(this.pricingInfo, input.code);
  }

  sumOfPriceBreakdown: string[];
}
